"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var KLINE_CAPITAL_DATA = {
  "stock": [{
    "count": 41,
    "stockday": [{
      "date": 20140320,
      "capital": {
        "a": 14922777132
      }
    }, {
      "date": 20140814,
      "capital": {
        "a": 14922777132
      }
    }, {
      "date": 20150319,
      "capital": {
        "a": 14922777132
      }
    }, {
      "date": 20150820,
      "capital": {
        "a": 14922777132
      }
    }, {
      "date": 20160322,
      "capital": {
        "a": 18653471415
      }
    }, {
      "date": 20160407,
      "capital": {
        "a": 18653471415
      }
    }, {
      "date": 20160616,
      "capital": {
        "a": 20518818557
      }
    }, {
      "date": 20160811,
      "capital": {
        "a": 20518818557
      }
    }, {
      "date": 20170314,
      "capital": {
        "a": 21618279922
      }
    }, {
      "date": 20170519,
      "capital": {
        "a": 28103763899
      }
    }, {
      "date": 20170830,
      "capital": {
        "a": 28103763899
      }
    }, {
      "date": 20170906,
      "capital": {
        "a": 28103763899
      }
    }, {
      "date": 20180830,
      "capital": {
        "a": 28103763899
      }
    }, {
      "date": 20190326,
      "capital": {
        "a": 28103763899
      }
    }, {
      "date": 20190823,
      "capital": {
        "a": 28103763899
      }
    }, {
      "date": 20200424,
      "capital": {
        "a": 28103763899
      }
    }, {
      "date": 20200702,
      "capital": {
        "a": 28103794812
      }
    }, {
      "date": 20200703,
      "capital": {
        "a": 28103794812
      }
    }, {
      "date": 20200715,
      "capital": {
        "a": 28103805551
      }
    }, {
      "date": 20200716,
      "capital": {
        "a": 28103805551
      }
    }, {
      "date": 20200828,
      "capital": {
        "a": 28103794812
      }
    }, {
      "date": 20200831,
      "capital": {
        "a": 29352131712
      }
    }, {
      "date": 20200901,
      "capital": {
        "a": 29352131712
      }
    }, {
      "date": 20201009,
      "capital": {
        "a": 29352134127
      }
    }, {
      "date": 20201012,
      "capital": {
        "a": 29352134127
      }
    }, {
      "date": 20210702,
      "capital": {
        "a": 29352156163
      }
    }, {
      "date": 20210712,
      "capital": {
        "a": 29352160584
      }
    }, {
      "date": 20210713,
      "capital": {
        "a": 29352160584
      }
    }, {
      "date": 20211008,
      "capital": {
        "a": 29352165582
      }
    }, {
      "date": 20220105,
      "capital": {
        "a": 29352168006
      }
    }, {
      "date": 20220106,
      "capital": {
        "a": 29352168006
      }
    }, {
      "date": 20220401,
      "capital": {
        "a": 29352171861
      }
    }, {
      "date": 20221011,
      "capital": {
        "a": 29352173656
      }
    }, {
      "date": 20230104,
      "capital": {
        "a": 29352174170
      }
    }, {
      "date": 20230105,
      "capital": {
        "a": 29352174170
      }
    }, {
      "date": 20230403,
      "capital": {
        "a": 29352174759
      }
    }, {
      "date": 20230404,
      "capital": {
        "a": 29352174759
      }
    }, {
      "date": 20230703,
      "capital": {
        "a": 29352175421
      }
    }, {
      "date": 20230704,
      "capital": {
        "a": 29352175421
      }
    }, {
      "date": 20230712,
      "capital": {
        "a": 29352175642
      }
    }, {
      "date": 20230713,
      "capital": {
        "a": 29352175642
      }
    }],
    "symbol": "600000.sh",
    "name": null
  }],
  "start": 0,
  "end": 0,
  "count": 1,
  "ticket": 266,
  "version": "HQ.StockHistoryDay 2.0",
  "message": null,
  "code": 0,
  "servertime": "2023-08-29 14:55:58"

  /*暴露外部用的方法*/
};exports.KLINE_CAPITAL_DATA = KLINE_CAPITAL_DATA;


//////////////////
// WEBPACK FOOTER
// ./~/hqchart/src/jscommon/umychart.vue.testdataV2/60000.sh.capital.kline.js
// module id = 307
// module chunks = 0